import * as React from "react";

const Sort = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    viewBox={"0 0 16 16"}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 12.664h6.667M4.667 8h10M1.333 3.332h13.334"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Sort;
